var map = {
	"./template.betgalaxy": 1075,
	"./template.betgalaxy.tsx": 1075,
	"./template.betprofessor": 2062,
	"./template.betprofessor.tsx": 2062,
	"./template.default": 409,
	"./template.default.tsx": 409,
	"./template.forsport": 1076,
	"./template.forsport.tsx": 1076,
	"./template.puntgenie": 2063,
	"./template.puntgenie.tsx": 2063,
	"./template.ts": 964,
	"./template.wellbet": 1988,
	"./template.wellbet.tsx": 1988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2420;